import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import openApp from '../utils/openApp'

import PhoneMask from '../componets/PhoneMask';
import './DownloadPage.css';
import { ReactComponent as Logo } from "../res/image/logo.svg"
import { Trans, useTranslation } from 'react-i18next'

declare var document: any;
declare var window: any;

interface ComponentProps {
    setGlobalToken: Function
}

const isIOS: boolean = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //iOS
const isAndroid: boolean = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1; //Android

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: "#000000bf",
        boxShadow: theme.shadows[1],
        fontSize: 16,
    },
}))(Tooltip);

const DownloadPage: React.FC<ComponentProps> = (props) => {
    const { setGlobalToken } = props
    const { t } = useTranslation()
    const [scheme, setScheme] = useState<string>('')

    const PageBg: React.FC = () => (
        <>
            <div className="page-bg-1"></div>
            <div className="page-bg-2"></div>
            <div className="page-bg-3"></div>
        </>
    )

    const resetIframe = () => {
        let schemeUrl = scheme
        const feloScheme = `felo://join.felo.me/`
        if (schemeUrl.indexOf(feloScheme) === -1) {
            schemeUrl = feloScheme
        }
        console.log('schemeUrl:', schemeUrl)
        openApp.open(schemeUrl, (code) => {
            switch (code) {
                case 'ios':
                    break;
                case 'android':
                    break;
            }
        }, () => {
            console.log('Failed to open Felo App')
        }, 100)
    }

    useEffect(() => {
        document.title = t('org.invite.title')
        let teamCode = document.getElementById("team_code").getAttribute("content");
        let inviteCode = document.getElementById("invite_code").getAttribute("content");

        let url = document.location.href;
        let urlOrigin =  document.location.origin;
        const schemeJoin = 'join.felo.me'
        if (urlOrigin.indexOf(schemeJoin) === -1) {
            url = url.replace(urlOrigin, `${document.location.protocol}//${schemeJoin}`)
        }
        url = url.replace("http://", "felo://")
        url = url.replace("https://", "felo://")
        url += `?inviteCode=${inviteCode}&orgCode=${teamCode}`

        setScheme(url)
    }, [])

    return (
        <div className="download-page">
            <PageBg />
            <PhoneMask />

            <section className="page-main">
                <div className="header">
                    <Logo />
                    <div className='title'>{t('download.title')}</div>
                </div>
                <div className='body'>
                    {/* <div className='desc'>{t('open.failed.install.app')}</div> */}
                    {
                        isIOS && (
                            <Button href="https://apps.apple.com/jp/app/felo/id1561575357" color="primary">
                                {t('download.app.ios')}
                            </Button>
                        )
                    }
                    {
                        isAndroid && (
                            <Button href="https://play.google.com/store/apps/details?id=app.felo.me" color="primary">
                                {t('download.app.android')}
                            </Button>
                        )
                    }
                </div>
                <div className='footer'>
                    <span>{t('app.installed')}</span>
                    <Button href="#" color="primary" onClick={resetIframe}>
                        {t('app.open')}
                    </Button>
                </div>
            </section>
        </div>
    )
}

const stateProps = (state: any) => {
    return {
    }
}

const dispatchProps = (dispatch: any) => ({
})

export default connect(stateProps, dispatchProps)(DownloadPage)